import { render, staticRenderFns } from "./LdButton.vue?vue&type=template&id=0b16dcd7&"
import script from "./LdButton.vue?vue&type=script&lang=js&"
export * from "./LdButton.vue?vue&type=script&lang=js&"
import style0 from "./LdButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports